import { chatListErrorsMapper } from '../../service/ChatListEditor/ChatListEditor';
import {
    ChatListEditorData,
    ChatListItem,
    ChatListValue
} from '../../typings/chatList';
import {
    ValidationErrorData,
    ValidationResultItem
} from '../../typings/common';
import { DialogsQuery_client_dialogs } from '../../typings/graphql-grid';
import { getStringFromApiFormat } from '../common/common';

export function mapChatListEditorValueToCampaignChatValue(
    chatListEditor: ChatListEditorData
): ChatListValue {
    return {
        selectedChatId: chatListEditor.selectedChatId
    };
}

export function mapDialogsApiDataResult(
    data: (DialogsQuery_client_dialogs | null)[]
): ChatListItem[] {
    if (!data) {
        return [];
    }

    return data.map((element: DialogsQuery_client_dialogs) => {
        return {
            id: getStringFromApiFormat(element.id)!, // TODO бек возвращает необязательное поле
            name: element.name,
            active: element.isActive,
            skillId: element.skillId
        };
    });
}

const DEFAULT_CHAT_LIST_API_ERRORS: Array<ValidationErrorData> = [];

export function mapChatListApiErrors(
    errors?: ValidationResultItem[]
): Array<ValidationErrorData> {
    if (!errors) {
        return DEFAULT_CHAT_LIST_API_ERRORS;
    }

    return errors.map(
        (error: ValidationResultItem): ValidationErrorData => {
            return {
                path: error.path,
                code: error.code,
                text: chatListErrorsMapper({ ...error })
            };
        }
    );
}
